import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'

export const useZone = () => {
  const [zone, setZone] = useState(false)
  const { deleteNewZone, getNewZones } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE, DELETE } = useRestApi(setLoading, 'Zone', 'ZONE')

  const getAllZone = async (dto = {}) => {

    console.log("zone", "zones2")
    GET_ALL('GET_ALL_ZONE_BY_COMPANY', setPaginate, getNewZones, dto)
  }

  const addZone = (dto) => {
    ADD('ADD_ZONE', dto)
  }

  const updateZone = (dto) => {
    UPDATE('EDIT_ZONE', dto)
  }

  const getZone = (dto) => {
    GET_SINGLE('GET_ZONE', setZone)
  }

  const deleteManyZone = (dto, setSelected = () => {}) => {
    DELETE('DELETE_MANY_ZONE', dto, 'zoneId', setSelected, deleteNewZone, 'GET_ALL_ZONE_BY_COMPANY')
  }

  return {
    addZone,
    getAllZone,
    getZone,
    zone,
    updateZone,
    deleteManyZone,
    loading,
    paginate,
  }
}
